import { useRef } from 'react';

export default function MasterclassSeries() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const masterclasses = [
    {
      number: '01',
      title: 'Anxiety Masterclass',
      description: 'A 10-part journey to better understand and master anxiety',
      duration: '25 min',
      status: 'Available'
    },
    {
      number: '02',
      title: 'Depression Masterclass (Coming Soon)',
      description: 'Master evidence-based breathing exercises for immediate calm',
      duration: '20 min',
      status: 'Coming Soon'
    },       
    
  ];

  return (
    <section id="masterclass" className="py-24 bg-[#2F7FB7] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#5A9FD4]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="mb-12">
          <h2 className="text-5xl font-serif text-white mb-6">The Masterclass Series</h2>
          <p className="text-xl text-white/90 max-w-3xl leading-relaxed">
            Professionally developed lessons that introduce practical, easy-to-apply strategies for understanding and managing mental health in everyday life.
          </p>
           <p className="text-xl text-white/90 max-w-3xl leading-relaxed">
          The Masterclass Series is continually expanded with new material, ensuring content remains current, relevant, and responsive to the evolving needs of subscribers.
          </p>
        </div>

        {/* Horizontal scroll container */}
        <div className="relative">
          <div 
            ref={scrollRef}
            className="flex gap-6 overflow-x-auto pb-8 snap-x snap-mandatory scrollbar-hide"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {masterclasses.map((module, index) => (
              <div 
                key={index}
                className="flex-shrink-0 w-[380px] bg-white rounded-3xl p-8 snap-start hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
              >
                <div className="flex items-start justify-between mb-6">
                  <span className="text-5xl font-serif text-[#2F7FB7]/30 font-bold">{module.number}</span>
                  <span className="bg-[#5A9FD4] text-white text-xs px-3 py-1.5 rounded-full whitespace-nowrap">
                    {module.status}
                  </span>
                </div>
                <h3 className="text-2xl font-serif text-[#2F7FB7] mb-3">{module.title}</h3>
                <p className="text-gray-600 leading-relaxed mb-6">{module.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500 flex items-center gap-2">
                    <i className="ri-time-line"></i>
                    {module.duration}
                  </span>
                  <a href="/download" className="text-[#2F7FB7] font-medium inline-flex items-center gap-2 group-hover:gap-3 transition-all whitespace-nowrap cursor-pointer">
                    Start Module
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Scroll indicators */}
          <div className="flex justify-center gap-2 mt-8">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="w-2 h-2 rounded-full bg-white/30"></div>
            ))}
            <div className="w-8 h-2 rounded-full bg-white"></div>
            {[...Array(3)].map((_, i) => (
              <div key={i} className="w-2 h-2 rounded-full bg-white/30"></div>
            ))}
          </div>
        </div>

        {/* Coming soon section */}
        <div className="mt-16 grid md:grid-cols-2 gap-8">
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
            <div className="flex items-center gap-3 mb-4">
              <i className="ri-time-line text-3xl text-white"></i>
              <span className="text-sm text-white/70 uppercase tracking-wider">Coming Soon</span>
            </div>
            <h3 className="text-2xl font-serif text-white mb-3">Depression Masterclass</h3>
            <p className="text-white/80 leading-relaxed">
              Evidence-based guidance for day-to-day mood regulation, emotional resilience, and recovery from depressive symptoms.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
            <div className="flex items-center gap-3 mb-4">
              <i className="ri-roadmap-line text-3xl text-white"></i>
              <span className="text-sm text-white/70 uppercase tracking-wider">Future Topics</span>
            </div>
            <h3 className="text-2xl font-serif text-white mb-3">More to Come</h3>
            <p className="text-white/80 leading-relaxed mb-4">
              Future Masterclasses will explore:
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="bg-white/20 text-white text-sm px-3 py-1.5 rounded-full whitespace-nowrap">Burnout Syndrome</span>
              <span className="bg-white/20 text-white text-sm px-3 py-1.5 rounded-full whitespace-nowrap">Chronic Pain Management</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
